import { Router } from '@angular/router';
import { AccountService } from './../service/account.service';

import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpErrorResponse } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

    constructor (
        private accountService: AccountService,
        private router: Router
    ) {}

    intercept(req: HttpRequest<any>, next: HttpHandler) {
        const token = this.accountService.obterToken();
        let request: HttpRequest<any> = req;
        if (token && !this.accountService.tokenExpirado(token)){
            // O request é imutavel, ou seja, não é possível mudar nada
            // Faço o clone para conseguir mudar as propriedades
            // Passo o token de autenticação no header
            request = req.clone({
                headers: req.headers.set('Authorization', `Bearer ${token}`)
            });
        }

        // retorno o request com o erro tratado
    return next.handle(request)
      .pipe(
        catchError(this.handleError)
      );
    }
    private handleError(error: HttpErrorResponse) {
        if (error.error instanceof ErrorEvent) {
            // Erro de client-side ou de rede
            console.error('Ocorreu um erro:', error.error.message);
        } else {
            // Erro retornando pelo backend
            console.error(
                `Código do erro ${error.status}, ` +
                `Erro: ${JSON.stringify(error.error)}`);
        }
        // retornar um observable com uma mensagem amigavel.
        if(error.status == 401) {
            return throwError(error.status);
        }
        return throwError(error);
        // return throwError(`${JSON.stringify(error.error)}`);
    }
}